<div class="frame-content form-field-density-4">
     <div class="tem-field full-width">
        <span class="tem-field-label">URL</span>
        <nz-input-group nzSearch [nzAddOnAfter]="suffixButton">
            <input nz-input [placeholder]="'webscraping.url.placeholder'|translateTA" #inp>
        </nz-input-group>
        <ng-template #suffixButton>
            <button nz-button nzType="primary" nzSearch aria-label="Navigate" (click)="navigate(inp.value)">
                <nz-icon nzType="search"></nz-icon>
            </button>
        </ng-template>
      </div>
      <nz-divider class="tight-divider"></nz-divider>
      <div class="pure-pusher" [hidden]="current_url==null">
        <iframe class="iframe-div"  target="_self" #iframe
            [src]="current_url" frameborder="0">
        </iframe>
      </div>
</div>
